import { render, staticRenderFns } from "./MultimediaQuestion.vue?vue&type=template&id=1f327ea0&scoped=true&"
import script from "./MultimediaQuestion.vue?vue&type=script&lang=js&"
export * from "./MultimediaQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MultimediaQuestion.vue?vue&type=style&index=0&id=1f327ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f327ea0",
  null
  
)

export default component.exports